// extracted by mini-css-extract-plugin
module.exports = {"title":"title___39FRa","cardFlex":"cardFlex___hp1gI","expansionBtn":"expansionBtn___3ki_N"};